export default __webpack_public_path__ + "static/media/pic2.03fe30c9.svg";